import { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// @mui
import { alpha } from '@mui/material/styles';
import { Avatar, Box, Divider, MenuItem, Stack, Typography } from '@mui/material';
//
import MenuPopover from 'components/MenuPopover';
import { IconButtonAnimate } from 'components/animate';
// routes
import useUser from '../../../hooks/useUser';

// ----------------------------------------------------------------------

const MENU_OPTIONS = [
  // {
  //   label: 'menu.home',
  //   linkTo: '/'
  // }
];

// ----------------------------------------------------------------------

export default function AccountPopover() {
  const { t } = useTranslation('header');
  const user = useUser();
  const [open, setOpen] = useState(null);

  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(null);
  };

  return (
    <>
      <IconButtonAnimate
        onClick={handleOpen}
        sx={{
          p: 0,
          ...(open && {
            '&:before': {
              zIndex: 1,
              content: "''",
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              position: 'absolute',
              bgcolor: (theme) => alpha(theme.palette.grey[900], 0.8)
            }
          })
        }}
      >
        <Avatar src={user.picture} alt={user.name} />
      </IconButtonAnimate>

      <MenuPopover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        sx={{
          p: 0,
          mt: 1.5,
          ml: 0.75,
          '& .MuiMenuItem-root': {
            typography: 'body2',
            borderRadius: 0.75
          }
        }}
      >
        <Box sx={{ my: 1.5, px: 2.5 }}>
          <Typography variant="subtitle2" noWrap>
            {user.name}
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
            {user.email}
          </Typography>
        </Box>

        <Divider sx={{ borderStyle: 'dashed' }} />

        <Stack sx={{ p: 1 }}>
          {MENU_OPTIONS.map((option) => (
            <MenuItem key={option.label} to={option.linkTo} component={RouterLink} onClick={handleClose}>
              {t(option.label)}
            </MenuItem>
          ))}
        </Stack>

        {MENU_OPTIONS.length > 0 && <Divider sx={{ borderStyle: 'dashed' }} />}

        <MenuItem onClick={() => window.clientInstance.killSession()} sx={{ m: 1 }}>
          {t('menu.logout')}
        </MenuItem>
      </MenuPopover>
    </>
  );
}
